export const baseStyles = theme => {
  return {
    center: {
      textAlign: 'left',
    },
    modalText: {
      margin: '5px 0 12px',
      lineHeight: '1.2',
    },
    modalTextBold: {
      marginLeft: '35%',
      lineHeight: '1.2',
      fontWeight: 'bold',
    },
    idleButton: {
      width: '103% !important',
      marginLeft: '50px',
    },
  };
};
